import CaptchaContainer from './CaptchaContainer';

export default CaptchaContainer;